<template>
  <div>
    <div class="ceiling">
      <home-top></home-top>
      <top-search :showHot="true" type="home"></top-search>
      <navicat :current="5" background="#fff"></navicat>
    </div>
    <!-- 头部占位 -->
    <!-- <div class="h-top"></div> -->
    <!-- banner图 -->
    <div class="bannre-box mini-width">
      <el-carousel height="400px">
        <el-carousel-item v-for="item in bannerList" :key="item.id">
          <img class="banner-image" :src="item.image"/>
        </el-carousel-item>
      </el-carousel>
    </div>
    <div class="banner-desc mini-width">
      <div class="w-1400 banner-desc-inner">
        <div class="image-box">
          <img :src="configInfo.about_us_img" alt="公司图标"/>
        </div>
        <div class="right-box">
          <div class="title">{{ configInfo.about_us_title }}</div>
          <div class="desc" v-html="configInfo.about_us_text"></div>
        </div>
      </div>
    </div>
    <!-- 企业荣誉 -->
    <div class="honor-box mini-width">
      <div class="w-1400 honor-box-inner">
        <div class="honor-box-title">
          <title-home title="企业荣誉" English="ENTERPRISE HONOR"></title-home>
        </div>
        <div class="swiper">
          <el-carousel arrow="hover" trigger="click" height="320px" :autoplay="false" ref="carousel">
            <el-carousel-item v-for="(group, groupIndex) in honorList" :key="groupIndex"
                              class="honoer-swiper-box-group">
              <div class="honoer-swiper-box">
                <!-- <honor-card :data="item" v-for="i in 4" :key="i"></honor-card> -->
                <div v-for="(item, index) in group" :key="index">
                  <honor-card :data="item"></honor-card>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- <div class="page-turning">
          <div class="page-turning-box">
            <div class="page-turning-cri" @click="prevSlide">
              <i class="el-icon-back"></i>
            </div>
            <div class="page-turning-cri" @click="nextSlide">
              <i class="el-icon-right"></i>
            </div>
          </div>
        </div> -->
      </div>
    </div>
    <!-- 企业资质 -->
    <div class="honor-box qualifications mini-width">
      <div class="w-1400 honor-box-inner">
        <div class="honor-box-title">
          <title-home title="企业资质" English="ENTERPRISE QUALIFICATION"></title-home>
        </div>
        <div class="swiper">
          <el-carousel arrow="hover" trigger="click" height="330px" :autoplay="false" ref="carousel">
            <el-carousel-item v-for="(group, groupIndex) in qualificationsList" :key="groupIndex"
                              :initial-index="initialCurrent">
              <div class="honoer-swiper-box">
                <div v-for="(item, index) in group" :key="index">
                  <honor-card background="#F9FAFF" :data="item"></honor-card>
                </div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
        <!-- <div class="page-turning">
          <div class="page-turning-box">
            <div class="page-turning-cri" @click="prevSlide">
              <i class="el-icon-back"></i>
            </div>
            <div class="page-turning-cri" @click="nextSlide">
              <i class="el-icon-right"></i>
            </div>
          </div>
        </div> -->
      </div>
    </div>

    <!-- 企业地址 -->
    <div class="address-box mini-width">
      <div class="w-1400 address-box-inner">
        <div class="address-box-left">
          <div class="conpan-one">
            <img class="conpan-img" src="../../static/index/about/qiye.png" alt=""/>
            <div class="conpan-one-inner">
              <div class="conpan-title">企业名称</div>
              <div class="conpan-desc">{{ configInfo.company_name }}</div>
            </div>
          </div>
          <div class="conpan-tow">
            <div class="conpan-title">工厂地址</div>
            <div class="conpan-desc">
              {{ configInfo.company_address }}
            </div>
          </div>
          <div class="conpan-three">
            <img class="conpan-img" src="../../static/index/about/phone.png" alt=""/>
            <div class="conpan-user-inner">
              <div class="conpan-title">联系人</div>
              <div class="conpan-desc">{{ configInfo.company_contract }}</div>
            </div>
            <div class="conpan-user-phone">
              <div class="conpan-title">联系电话</div>
              <div class="conpan-desc">{{ configInfo.site_mible }}</div>
            </div>
          </div>
        </div>
        <div class="address-box-right">
          <div class="watch-box flex-b">
            <div class="watch-conpan">
              <div class="watch-img">
                <img :src="configInfo.wechat_qrcode" alt="微信公众号图片"/>
              </div>
              <div>
                <div class="watch-title">微信公众号</div>
                <div class="watch-title">化联网</div>
              </div>
            </div>
            <div class="watch-conpan">
              <div class="watch-img">
                <img :src="configInfo.mini_qrcode" alt="微信小程序图片"/>
              </div>
              <div>
                <div class="watch-title">微信小程序</div>
                <div class="watch-title">化联网</div>
              </div>
            </div>
          </div>
          <div class="emil-box">
            <img src="../../static/index/about/email.png" class="conpan-img" alt=""/>
            <div class="emil-inner">
              <div class="conpan-title">邮箱</div>
              <div class="conpan-desc">{{ configInfo.site_mail }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="map-box mini-width">
      <div class="map" id="amap-container"></div>
    </div>

    <home-footer></home-footer>
  </div>
</template>
<script>
import topSearch from "../../components/public/top-search.vue";
import homeTop from "../../components/public/home-top.vue";
import navicat from "../../components/navicat/navicat.vue";
import titleHome from "../../components/Title/title-home.vue";
import honorCard from "../../components/goods/honor-card.vue";
import homeFooter from "../../components/public/home-footer.vue";
import {getSwiperList} from "@/api/modules/common";
import {getCompanyInfo} from "@/api/modules/home";
import {addLdJsonToHead, removeLdJsonFromHead} from "@/utils/ldJson";

export default {
  name: "about-us",
  components: {
    topSearch,
    homeTop,
    navicat,
    titleHome,
    honorCard,
    homeFooter,
  },
  data() {
    return {
      bannerDesc: {
        title: "化联网·化工行业领导者",
      },
      honorList: [],
      initialCurrent: 1,
      bannerList: [],
      qualificationsList: [],
      map: null, // 保存地图实例
    };
  },
  computed: {
    configInfo() {
      return this.$store.state.config.config;
    },
  },
  created() {
    this.getBannert();
    this.getCompany();
  },
  mounted() {
    this.$nextTick(() => {
      this.initMap();
    });
    const ldData = {
      "@context": "https://schema.org",
      "@type": "Organization",
      "name": "化联网",
      "alternateName": "Chemical-Link",
      "url": "https://www.chemical-link.com",
      "logo": "https://www.chemical-link.com/static/logo.png",
      "description": "化联网是专注化工领域的B2B资源对接平台，聚焦化工原料采购、化学品销售、来料加工对接、技术合作匹配等场景，助力化工企业高效链接全球资源，实现供需精准匹配与交易安全保障。",
      "contactPoint": {
        "@type": "ContactPoint",
        "telephone": "17333486080",
        "contactType": "客服",
        "email": "service@chemical-link.com"
      },
      "address": {
        "@type": "PostalAddress",
        "streetAddress": "河北省石家庄市裕华区建通街道塔南路39号超达晶彩中心广场F号办公楼",
        "addressLocality": "河北省",
        "addressRegion": "石家庄市",
        "postalCode": "050000",
        "addressCountry": "CN"
      },
      "sameAs": [
        "https://mp.weixin.qq.com/s/C0_Efg7yX3M_V5TMkF9u_A",
        "https://tieba.baidu.com/p/10281556568",
        "深度揭秘：化联网——化工行业的革新引擎 - 化联网撮合平台的文章 - 知乎https://zhuanlan.zhihu.com/p/1981362663012450747",
        "https://www.bilibili.com/opus/1143930265507201025?_unique_id_=8540a6bf-29dc-4a6f-a6a2-d371f9b3eedd&code=011TPZ1w3AKj663Fd01w3yD22j4TPZ1B&state="

      ]
    };
    const productLdData = {
      "@context": "https://schema.org",
      "@type": "Product",
      "name": "化联网化工B2B平台",
      "brand": {
        "@type": "Organization",
        "name": "化联网"
      },
      "description": "化联网平台覆盖精细化工、工业化学品、食品添加剂、化工设备等全品类资源，提供智能供需匹配、企业资质核验、交易流程跟踪、行业资讯推送等核心服务，支持免费发布采购/销售需求，帮助化工企业降低对接成本、提升交易效率。",
      "category": "化工B2B服务平台",
      "offers": {
        "@type": "Offer",
        "price": "0",
        "priceCurrency": "CNY",
        "availability": "https://schema.org/InStock",
        "url": "https://www.chemical-link.com/register"
      },
      "image": "https://www.chemical-link.com/static/banner.png",
      "aggregateRating": {
        "@type": "AggregateRating",
        "ratingValue": "4.8",
        "reviewCount": "1200+"
      }
    }
    addLdJsonToHead(ldData, 'org-ld-json');
    addLdJsonToHead(productLdData, 'product-ld-json');
  },
  beforeRouteLeave(to, from, next) {
    removeLdJsonFromHead('org-ld-json');
    removeLdJsonFromHead('product-ld-json');
    next();
  },
  beforeDestroy() {
    // 销毁地图实例，避免内存泄漏
    if (this.map) {
      this.map.destroy();
    }
  },
  methods: {
    initMap() {
      // 初始化高德地图
      const map = new AMap.Map("amap-container", {
        zoom: 15,
        center: [114.50467700000002, 38.008974000000016], // 石家庄市中心坐标
        mapStyle: "amap://styles/normal",
      });

      // 添加标记点
      const marker = new AMap.Marker({
        position: [114.50467700000002, 38.008974000000016],
        title: "石家庄化联网有限公司",
        icon: new AMap.Icon({
          // 图标尺寸
          size: new AMap.Size(25, 34),
          // 图标的取图地址
          image: "https://webapi.amap.com/theme/v1.3/markers/n/mark_r.png",
          // image: '../../static/index/about/location.png',
          // 图标所用图片大小
          imageSize: new AMap.Size(25, 34),
        }),
      });

      // 将标记点添加到地图
      map.add(marker);

      // 添加信息窗体
      const infoWindow = new AMap.InfoWindow({
        content: `
          <div style="padding: 10px;">
            <h4 style="margin: 0 0 5px 0;">石家庄化联网有限公司</h4>
            <p style="margin: 0; color: #666;">${this.configInfo.company_address}</p>
          </div>
        `,
        offset: new AMap.Pixel(0, -30),
      });

      // 点击标记点显示信息窗体
      marker.on("click", () => {
        infoWindow.open(map, marker.getPosition());
      });

      // 保存地图实例
      this.map = map;
    },
    chunkArray(array, size) {
      const chunks = [];
      for (let i = 0; i < array.length; i += size) {
        chunks.push(array.slice(i, i + size));
      }
      return chunks;
    },
    getCompany() {
      getCompanyInfo(1).then((res) => {
        // 将数组分成5个为一组
        const data = res.data.data;
        this.qualificationsList = this.chunkArray(data, 5);
      });
      getCompanyInfo(2).then((res) => {
        // 将数组分成5个为一组
        const data = res.data.data;
        this.honorList = this.chunkArray(data, 5);
      });
    },
    getBannert() {
      getSwiperList(3).then((res) => {
        this.bannerList = res.data.data;
      });
    },
    prevSlide() {
      this.$refs.carousel.prev();
    },
    nextSlide() {
      this.$refs.carousel.next();
    },
  },
};
</script>
<style lang="scss" scoped>

.map {
  height: 320px;
  // width: 1400px;
  margin: 0 auto;
  background: #d3d3d3;
  position: relative;
}

.map-box {
  background: #F9FAFF;
}

.qualifications {
  background: #ffffff !important;
}

.h-top {
  // height: 157px;
  //height: 80px;
  height: 265px;
}

.bannre-box {
  width: 100%;
  height: 400px;

  .banner-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.banner-desc {
  width: 100%;
  // height: 476px;
  background: #ffffff;
  border-radius: 0px 0px 0px 0px;

  .banner-desc-inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 60px 0;

    .image-box {
      width: 504px;
      height: 356px;
      background: #d1d5e3;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    .right-box {
      width: 867px;
      margin-left: 29px;
      height: 356px;

      .title {
        line-height: 40px;
        font-weight: bold;
        font-size: var(--font-size-default-18);
        color: #00112b;
        // padding-left: 24px;
      }

      .desc {
        font-weight: 400;
        font-size: var(--font-size-default-14);
        color: #5f616c;
        line-height: 30px;
      }
    }
  }
}

.honor-box {
  position: relative;
  width: 100%;
  background: #f9faff;
  padding-bottom: 40px;

  .honor-box-title {
    padding: 40px 0 20px;
  }

  .honoer-swiper-box {
    display: flex;
    justify-content: space-between;
    padding: 0 80px;
  }

  .page-turning {
    position: absolute;
    width: 100%;
    background: rgba(189, 39, 39, 0.8);
    top: 0;
    left: 0;
    // margin-top: 20px;
    .page-turning-box {
      background: rgba(68, 54, 54, 0.8);
      display: flex;

      justify-content: space-between;
      align-items: center;
      margin: 0 auto;
      padding: 0 100px;
      height: 80px;

      .page-turning-cri {
        cursor: pointer;
        display: inline-block;
        width: 80px;
        height: 80px;
        border-radius: 50%;
        background: #ffffff;
        border: 1px solid #eef0f5;
        text-align: center;
        line-height: 80px;
        font-size: 27px;
        color: #000000;
      }
    }
  }
}

.address-box {
  padding: 100px 0;
  width: 100%;
  background: #f9faff;

  .address-box-inner {
    display: flex;

    .conpan-img {
      width: 50px;
      height: 50px;
    }

    .conpan-title {
      font-weight: bold;
      font-size: var(--font-size-default-big);
      color: #333333;
      margin-bottom: 10px;
    }

    .conpan-desc {
      font-weight: 500;
      font-size: 18px;
      color: #5f616c;
    }

    .address-box-left {
      .conpan-one {
        display: flex;
        align-items: center;

        .conpan-one-inner {
          margin-left: 50px;
        }
      }

      .conpan-tow {
        padding: 59px 0 90px 100px;
      }

      .conpan-three {
        display: flex;
        align-items: center;

        .conpan-user-inner {
          margin: 0 150px 0 50px;
        }
      }
    }

    .address-box-right {
      margin-left: 178px;

      .emil-box {
        display: flex;
        align-items: center;
        margin-top: 40px;

        .emil-inner {
          margin-left: 50px;
        }
      }

      .watch-box {
        .watch-conpan {
          margin-right: 62px;
        }

        .watch-img {
          width: 188px;
          height: 188px;
          background: #f4f6f9;

          img {
            width: 100%;
            height: 100%;
            object-fit: contain;
          }
        }

        .watch-title {
          font-weight: 500;
          font-size: 18px;
          color: #5f616c;
          line-height: 30px;
        }
      }
    }
  }
}
</style>
